import { render, staticRenderFns } from "./ViewTelaFormulario.vue?vue&type=template&id=dbb2ceaa&scoped=true"
import script from "./ViewTelaFormulario.vue?vue&type=script&lang=js"
export * from "./ViewTelaFormulario.vue?vue&type=script&lang=js"
import style0 from "./ViewTelaFormulario.vue?vue&type=style&index=0&id=dbb2ceaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb2ceaa",
  null
  
)

export default component.exports